/**
 * /**
 *  * Generated by orval v1.0.0 🍃
 *  * Do not edit manually.
 *  * Citrus API
 *  * API for Citrus platform
 *  *\/
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DatasetsRegionDatasetsAnalyzeRetrieveParams,
  DatasetsRegionDatasetsListParams,
  PaginatedRegionDatasetList,
  PatchedRegionDatasetRequest,
  RegionDatasetAnalyzeResponse,
  RegionDatasetCreateResponse,
  RegionDatasetDeleteResponse,
  RegionDatasetGetResponse,
  RegionDatasetPutResponse,
  RegionDatasetRequest,
  RegionDatasetUpdateResponse
} from '../../models';

import { customInstance } from '../../../axios-instance';




/**
 * Retrieve a paginated list of regional dataset variants with filtering, search, and ordering capabilities.
 * @summary List regional datasets
 */
export const datasetsRegionDatasetsList = (
    params?: DatasetsRegionDatasetsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedRegionDatasetList>(
      {url: `/api/datasets/region-datasets/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getDatasetsRegionDatasetsListQueryKey = (params?: DatasetsRegionDatasetsListParams,) => {
    return [`/api/datasets/region-datasets/`, ...(params ? [params]: [])] as const;
    }

    
export const getDatasetsRegionDatasetsListQueryOptions = <TData = Awaited<ReturnType<typeof datasetsRegionDatasetsList>>, TError = unknown>(params?: DatasetsRegionDatasetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDatasetsRegionDatasetsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof datasetsRegionDatasetsList>>> = ({ signal }) => datasetsRegionDatasetsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DatasetsRegionDatasetsListQueryResult = NonNullable<Awaited<ReturnType<typeof datasetsRegionDatasetsList>>>
export type DatasetsRegionDatasetsListQueryError = unknown


export function useDatasetsRegionDatasetsList<TData = Awaited<ReturnType<typeof datasetsRegionDatasetsList>>, TError = unknown>(
 params: undefined |  DatasetsRegionDatasetsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsRegionDatasetsList>>,
          TError,
          Awaited<ReturnType<typeof datasetsRegionDatasetsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsRegionDatasetsList<TData = Awaited<ReturnType<typeof datasetsRegionDatasetsList>>, TError = unknown>(
 params?: DatasetsRegionDatasetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsRegionDatasetsList>>,
          TError,
          Awaited<ReturnType<typeof datasetsRegionDatasetsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsRegionDatasetsList<TData = Awaited<ReturnType<typeof datasetsRegionDatasetsList>>, TError = unknown>(
 params?: DatasetsRegionDatasetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List regional datasets
 */

export function useDatasetsRegionDatasetsList<TData = Awaited<ReturnType<typeof datasetsRegionDatasetsList>>, TError = unknown>(
 params?: DatasetsRegionDatasetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDatasetsRegionDatasetsListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create a new regional dataset variant with optional file upload and metrics.
 * @summary Create regional dataset
 */
export const datasetsRegionDatasetsCreate = (
    regionDatasetRequest: RegionDatasetRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<RegionDatasetCreateResponse>(
      {url: `/api/datasets/region-datasets/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: regionDatasetRequest, signal
    },
      );
    }
  


export const getDatasetsRegionDatasetsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsCreate>>, TError,{data: RegionDatasetRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsCreate>>, TError,{data: RegionDatasetRequest}, TContext> => {

const mutationKey = ['datasetsRegionDatasetsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof datasetsRegionDatasetsCreate>>, {data: RegionDatasetRequest}> = (props) => {
          const {data} = props ?? {};

          return  datasetsRegionDatasetsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DatasetsRegionDatasetsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof datasetsRegionDatasetsCreate>>>
    export type DatasetsRegionDatasetsCreateMutationBody = RegionDatasetRequest
    export type DatasetsRegionDatasetsCreateMutationError = unknown

    /**
 * @summary Create regional dataset
 */
export const useDatasetsRegionDatasetsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsCreate>>, TError,{data: RegionDatasetRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof datasetsRegionDatasetsCreate>>,
        TError,
        {data: RegionDatasetRequest},
        TContext
      > => {

      const mutationOptions = getDatasetsRegionDatasetsCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Get a single regional dataset by ID
 * @summary Retrieve regional dataset
 */
export const datasetsRegionDatasetsRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<RegionDatasetGetResponse>(
      {url: `/api/datasets/region-datasets/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getDatasetsRegionDatasetsRetrieveQueryKey = (id: number,) => {
    return [`/api/datasets/region-datasets/${id}`] as const;
    }

    
export const getDatasetsRegionDatasetsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof datasetsRegionDatasetsRetrieve>>, TError = RegionDatasetGetResponse>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDatasetsRegionDatasetsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof datasetsRegionDatasetsRetrieve>>> = ({ signal }) => datasetsRegionDatasetsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DatasetsRegionDatasetsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof datasetsRegionDatasetsRetrieve>>>
export type DatasetsRegionDatasetsRetrieveQueryError = RegionDatasetGetResponse


export function useDatasetsRegionDatasetsRetrieve<TData = Awaited<ReturnType<typeof datasetsRegionDatasetsRetrieve>>, TError = RegionDatasetGetResponse>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsRegionDatasetsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof datasetsRegionDatasetsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsRegionDatasetsRetrieve<TData = Awaited<ReturnType<typeof datasetsRegionDatasetsRetrieve>>, TError = RegionDatasetGetResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsRegionDatasetsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof datasetsRegionDatasetsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsRegionDatasetsRetrieve<TData = Awaited<ReturnType<typeof datasetsRegionDatasetsRetrieve>>, TError = RegionDatasetGetResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve regional dataset
 */

export function useDatasetsRegionDatasetsRetrieve<TData = Awaited<ReturnType<typeof datasetsRegionDatasetsRetrieve>>, TError = RegionDatasetGetResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDatasetsRegionDatasetsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Fully update a regional dataset with optional file upload
 * @summary Update regional dataset (full)
 */
export const datasetsRegionDatasetsUpdate = (
    id: number,
    regionDatasetRequest: RegionDatasetRequest,
 ) => {
      
      
      return customInstance<RegionDatasetPutResponse>(
      {url: `/api/datasets/region-datasets/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: regionDatasetRequest
    },
      );
    }
  


export const getDatasetsRegionDatasetsUpdateMutationOptions = <TError = RegionDatasetPutResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsUpdate>>, TError,{id: number;data: RegionDatasetRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsUpdate>>, TError,{id: number;data: RegionDatasetRequest}, TContext> => {

const mutationKey = ['datasetsRegionDatasetsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof datasetsRegionDatasetsUpdate>>, {id: number;data: RegionDatasetRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  datasetsRegionDatasetsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DatasetsRegionDatasetsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof datasetsRegionDatasetsUpdate>>>
    export type DatasetsRegionDatasetsUpdateMutationBody = RegionDatasetRequest
    export type DatasetsRegionDatasetsUpdateMutationError = RegionDatasetPutResponse

    /**
 * @summary Update regional dataset (full)
 */
export const useDatasetsRegionDatasetsUpdate = <TError = RegionDatasetPutResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsUpdate>>, TError,{id: number;data: RegionDatasetRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof datasetsRegionDatasetsUpdate>>,
        TError,
        {id: number;data: RegionDatasetRequest},
        TContext
      > => {

      const mutationOptions = getDatasetsRegionDatasetsUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Partially update a regional dataset with optional file upload
 * @summary Update regional dataset
 */
export const datasetsRegionDatasetsPartialUpdate = (
    id: number,
    patchedRegionDatasetRequest: PatchedRegionDatasetRequest,
 ) => {
      
      
      return customInstance<RegionDatasetUpdateResponse>(
      {url: `/api/datasets/region-datasets/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedRegionDatasetRequest
    },
      );
    }
  


export const getDatasetsRegionDatasetsPartialUpdateMutationOptions = <TError = RegionDatasetUpdateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsPartialUpdate>>, TError,{id: number;data: PatchedRegionDatasetRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsPartialUpdate>>, TError,{id: number;data: PatchedRegionDatasetRequest}, TContext> => {

const mutationKey = ['datasetsRegionDatasetsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof datasetsRegionDatasetsPartialUpdate>>, {id: number;data: PatchedRegionDatasetRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  datasetsRegionDatasetsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DatasetsRegionDatasetsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof datasetsRegionDatasetsPartialUpdate>>>
    export type DatasetsRegionDatasetsPartialUpdateMutationBody = PatchedRegionDatasetRequest
    export type DatasetsRegionDatasetsPartialUpdateMutationError = RegionDatasetUpdateResponse

    /**
 * @summary Update regional dataset
 */
export const useDatasetsRegionDatasetsPartialUpdate = <TError = RegionDatasetUpdateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsPartialUpdate>>, TError,{id: number;data: PatchedRegionDatasetRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof datasetsRegionDatasetsPartialUpdate>>,
        TError,
        {id: number;data: PatchedRegionDatasetRequest},
        TContext
      > => {

      const mutationOptions = getDatasetsRegionDatasetsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Delete a regional dataset by ID
 * @summary Delete regional dataset
 */
export const datasetsRegionDatasetsDestroy = (
    id: number,
 ) => {
      
      
      return customInstance<RegionDatasetDeleteResponse>(
      {url: `/api/datasets/region-datasets/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDatasetsRegionDatasetsDestroyMutationOptions = <TError = RegionDatasetDeleteResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsDestroy>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['datasetsRegionDatasetsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof datasetsRegionDatasetsDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  datasetsRegionDatasetsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DatasetsRegionDatasetsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof datasetsRegionDatasetsDestroy>>>
    
    export type DatasetsRegionDatasetsDestroyMutationError = RegionDatasetDeleteResponse

    /**
 * @summary Delete regional dataset
 */
export const useDatasetsRegionDatasetsDestroy = <TError = RegionDatasetDeleteResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsDestroy>>, TError,{id: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof datasetsRegionDatasetsDestroy>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDatasetsRegionDatasetsDestroyMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Analyze a region dataset with specified action and return analysis results
 * @summary Analyze region dataset
 */
export const datasetsRegionDatasetsAnalyzeRetrieve = (
    id: string,
    params: DatasetsRegionDatasetsAnalyzeRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<RegionDatasetAnalyzeResponse>(
      {url: `/api/datasets/region-datasets/${id}/analyze`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getDatasetsRegionDatasetsAnalyzeRetrieveQueryKey = (id: string,
    params: DatasetsRegionDatasetsAnalyzeRetrieveParams,) => {
    return [`/api/datasets/region-datasets/${id}/analyze`, ...(params ? [params]: [])] as const;
    }

    
export const getDatasetsRegionDatasetsAnalyzeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof datasetsRegionDatasetsAnalyzeRetrieve>>, TError = RegionDatasetAnalyzeResponse>(id: string,
    params: DatasetsRegionDatasetsAnalyzeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsAnalyzeRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDatasetsRegionDatasetsAnalyzeRetrieveQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof datasetsRegionDatasetsAnalyzeRetrieve>>> = ({ signal }) => datasetsRegionDatasetsAnalyzeRetrieve(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsAnalyzeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DatasetsRegionDatasetsAnalyzeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof datasetsRegionDatasetsAnalyzeRetrieve>>>
export type DatasetsRegionDatasetsAnalyzeRetrieveQueryError = RegionDatasetAnalyzeResponse


export function useDatasetsRegionDatasetsAnalyzeRetrieve<TData = Awaited<ReturnType<typeof datasetsRegionDatasetsAnalyzeRetrieve>>, TError = RegionDatasetAnalyzeResponse>(
 id: string,
    params: DatasetsRegionDatasetsAnalyzeRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsAnalyzeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsRegionDatasetsAnalyzeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof datasetsRegionDatasetsAnalyzeRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsRegionDatasetsAnalyzeRetrieve<TData = Awaited<ReturnType<typeof datasetsRegionDatasetsAnalyzeRetrieve>>, TError = RegionDatasetAnalyzeResponse>(
 id: string,
    params: DatasetsRegionDatasetsAnalyzeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsAnalyzeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof datasetsRegionDatasetsAnalyzeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof datasetsRegionDatasetsAnalyzeRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDatasetsRegionDatasetsAnalyzeRetrieve<TData = Awaited<ReturnType<typeof datasetsRegionDatasetsAnalyzeRetrieve>>, TError = RegionDatasetAnalyzeResponse>(
 id: string,
    params: DatasetsRegionDatasetsAnalyzeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsAnalyzeRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Analyze region dataset
 */

export function useDatasetsRegionDatasetsAnalyzeRetrieve<TData = Awaited<ReturnType<typeof datasetsRegionDatasetsAnalyzeRetrieve>>, TError = RegionDatasetAnalyzeResponse>(
 id: string,
    params: DatasetsRegionDatasetsAnalyzeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof datasetsRegionDatasetsAnalyzeRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDatasetsRegionDatasetsAnalyzeRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



